import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_2 = { class: "card-body p-xl-40" }
const _hoisted_3 = { class: "py-4 text-center text-muted" }
const _hoisted_4 = {
  key: 2,
  class: "qty-chip"
}
const _hoisted_5 = {
  key: 5,
  class: "action-buttons"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_table, {
        columns: _ctx.columns,
        "data-source": _ctx.products,
        "row-key": 'id',
        loading: _ctx.loading,
        pagination: _ctx.pagination,
        "row-selection": _ctx.rowSelection,
        scroll: { x: 1160 },
        class: "text-nowrap align-middle product-report-table",
        onChange: _ctx.handleChange
      }, {
        emptyText: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.i18nScope}.no_product_reports_found`)), 1)
        ]),
        bodyCell: _withCtx(({ column, record }) => [
          (column && column.key === 'type')
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["type-badge", Number(record.Type) === 1 ? 'type-standard' : 'type-service'])
              }, _toDisplayString(Number(record.Type) === 1 ? _ctx.$t(`${_ctx.i18nScope}.type_standard`) : _ctx.$t(`${_ctx.i18nScope}.type_service`)), 3))
            : (column && column.key === 'price')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" $" + _toDisplayString(_ctx.formatAmount(record.Price)), 1)
                ], 64))
              : (column && column.key === 'quantity')
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(Number(record.Qty ?? 0)), 1))
                : (column && column.key === 'ordered')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createTextVNode(_toDisplayString(Number(record.Total_Ordered ?? 0)), 1)
                    ], 64))
                  : (column && column.key === 'revenue')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        _createTextVNode(" $" + _toDisplayString(_ctx.formatAmount(record.Revenue)), 1)
                      ], 64))
                    : (column && column.key === 'action')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_component_router_link, {
                            to: `/product-details?id=${record.id}`,
                            title: _ctx.$t(`${_ctx.i18nScope}.view`)
                          }, {
                            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                              _createElementVNode("i", { class: "ri-eye-line" }, null, -1)
                            ]))]),
                            _: 1
                          }, 8, ["to", "title"]),
                          _createVNode(_component_router_link, {
                            to: `/edit-product?id=${record.id}`,
                            title: _ctx.$t(`${_ctx.i18nScope}.edit`)
                          }, {
                            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                              _createElementVNode("i", { class: "ri-edit-line" }, null, -1)
                            ]))]),
                            _: 1
                          }, 8, ["to", "title"])
                        ]))
                      : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["columns", "data-source", "loading", "pagination", "row-selection", "onChange"])
    ])
  ]))
}